import { render, staticRenderFns } from "./WorkOrderListView.vue?vue&type=template&id=512579f7&scoped=true&"
import script from "./WorkOrderListView.vue?vue&type=script&lang=ts&"
export * from "./WorkOrderListView.vue?vue&type=script&lang=ts&"
import style0 from "./WorkOrderListView.vue?vue&type=style&index=0&id=512579f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512579f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
